import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import TopicWall from "./components/TopicWall";
import TrackFeatures from "./components/TrackFeatures";
import ArchiveGrid from "./components/ArchiveGrid";
import CaseTimeline from "./components/CaseTimeline";
import RelationSection from "./components/RelationSection";
import CtaFooter from "./components/CtaFooter";

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <TopNav />
      <Hero />
      <main>
        <HotRank />
        <TopicWall />
        <TrackFeatures />
        <ArchiveGrid />
        <CaseTimeline />
        <RelationSection />
      </main>
      <CtaFooter />
    </div>
  );
}